export const AliPay = 50
export const WeChat = 31
